import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import QrCreate from "./pages/QrCreate";
import QrEdit from "./pages/QrEdit";
import { useAuthenticatedFetch } from "./hooks";

export default function App() {
  const fetch = useAuthenticatedFetch();

  const [shopDomain] = useState(() => {
    return new URLSearchParams(location.search).get("shop");
  });

  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch("/api/shopify/user/load", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((response) => setUser(response));
  }, []);

  return (
    <Routes>
      <Route path="/api/shopify/" element={<Home user={user} />} />
      <Route
        path="/api/shopify/qr/create"
        element={<QrCreate shopDomain={shopDomain} user={user} />}
      />
      <Route
        path="/api/shopify/qr/:id"
        element={<QrEdit shopDomain={shopDomain} user={user} />}
      />
      <Route path="/api/shopify/*" element={<Home />} />
    </Routes>
  );
}
